import React from 'react';
import PropTypes from 'prop-types';
import Clearfix from 'components/elements/clearfix';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import { setMenuSelected } from '@redux/actions/menuAction';
import moment from 'moment';
import { DATE_FORMAT } from 'config';
import slug from 'constants/slug';
import styled from 'styled-components';
import { COLOR } from 'config';

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;

class FacilitypermitPanel extends React.Component {
  static propTypes = {
    facilityId: PropTypes.string.isRequired,
    hideRightHeaderContent: PropTypes.bool,
    dataList: PropTypes.array,
  };

  render() {
    return (
      <div style={{ width: '100%' }}>
        <Clearfix height={8} />
        <FacilitypermitList
          hideRightHeaderContent
          facilityId={this.props.facilityId}
          dataList={this.props.dataList}
        />
      </div>
    );
  }
}

class FacilitypermitList extends BaseListContainer {
  static propTypes = {
    facilityId: PropTypes.string,
    hideRightHeaderContent: PropTypes.bool,
  };

  constructor(props) {
    const funcApi = {};
    const columns = [
      {
        dataField: 'LicenseNumber',
        text: 'Số giấy phép',
        formatter: (cell, row) => {
          return (
            <Link
              target='_blank'
              to={slug.FACILITY_PERMIT.VIEW_WITH_ID + row._id}
              onClick={() => {
                this.props.setMenuSelected_2(null);
              }}
            >
              <NameContainer>{cell ? cell.value : ''}</NameContainer>
            </Link>
          );
        },
      },

      {
        dataField: 'permitType',
        text: 'Loại giấy phép',
        formatter: (cell, row) => {
          return <div>{cell ? cell.Name : ''}</div>;
        },
      },
      {
        dataField: 'LicenseName',
        text: 'Tên giấy phép',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'IssueDate',
        text: 'Ngày cấp',
        formatter: (cell, row) => {
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
      {
        dataField: 'ExpiryDate',
        text: 'Ngày hết hạn',
        formatter: (cell, row) => {
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
    ];
    super(
      props,
      funcApi,
      columns,
      `${slug.FACILITY_PERMIT.CREATE}?facilityId=${props.facilityId}`,
      'facilityPermit',
      null,
      false
    );

    this.state = {
      ...this.state,
      valueSearch: {
        facility: this.props.facilityId,
      },
      dataList: this.props.dataList,
      isLoading: false,
    };
  }
}

const mapStateToProps = (state) => ({
  menuStore: state.menu,
});

const mapDispatchToProps = {
  setMenuSelected,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FacilitypermitPanel)
);



// WEBPACK FOOTER //
// ./src/containers/Coso/CosoView/FacilitypermitPanel/index.js